import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const COLORS = {
  clicks: "#ffb84d",
  registrations: "#1dd9af",
  ftd: "#54a3ff",
};

export default function DashboardChart({ data = [], loading = false }) {
  return (
    <div className="rounded-[28px] border border-white/10 bg-[rgba(11,18,31,0.92)] p-6 shadow-[0_30px_80px_rgba(0,0,0,0.28)]">
      <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--aff-muted)]">
            Performance
          </div>
          <h2 className="text-xl font-black text-white">Clicks, registrations and FTD trend</h2>
        </div>
        <div className="text-sm text-slate-400">Last 6 months</div>
      </div>

      {loading ? (
        <div className="flex h-[340px] items-center justify-center rounded-3xl border border-dashed border-white/10 text-sm text-slate-400">
          Loading performance chart...
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={340}>
          <AreaChart data={data} margin={{ top: 12, right: 8, left: -12, bottom: 0 }}>
            <defs>
              <linearGradient id="chart-clicks" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={COLORS.clicks} stopOpacity={0.28} />
                <stop offset="95%" stopColor={COLORS.clicks} stopOpacity={0} />
              </linearGradient>
              <linearGradient id="chart-registrations" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={COLORS.registrations} stopOpacity={0.25} />
                <stop offset="95%" stopColor={COLORS.registrations} stopOpacity={0} />
              </linearGradient>
              <linearGradient id="chart-ftd" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={COLORS.ftd} stopOpacity={0.25} />
                <stop offset="95%" stopColor={COLORS.ftd} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="rgba(148, 163, 184, 0.12)" vertical={false} />
            <XAxis dataKey="date" tick={{ fill: "#94a3b8", fontSize: 12 }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fill: "#94a3b8", fontSize: 12 }} axisLine={false} tickLine={false} />
            <Tooltip
              contentStyle={{
                backgroundColor: "#0b1220",
                borderColor: "rgba(255,255,255,0.08)",
                borderRadius: "16px",
                color: "#fff",
              }}
            />
            <Legend />
            <Area
              type="monotone"
              dataKey="clicks"
              stroke={COLORS.clicks}
              fill="url(#chart-clicks)"
              strokeWidth={2}
              name="Clicks"
            />
            <Area
              type="monotone"
              dataKey="registrations"
              stroke={COLORS.registrations}
              fill="url(#chart-registrations)"
              strokeWidth={2}
              name="Registrations"
            />
            <Area
              type="monotone"
              dataKey="ftd"
              stroke={COLORS.ftd}
              fill="url(#chart-ftd)"
              strokeWidth={2}
              name="FTD"
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
